import { createRouter as createTanStackRouter } from "@tanstack/react-router";
import { RouteError } from "./components/route-error";
import { initSentry } from "./integrations/sentry/sentry";
import TanStackQueryProvider, {
	getContext,
} from "./integrations/tanstack-query/root-provider";
import { TolgeeProviderWrapper } from "./integrations/tolgee/tolgee-provider";
import { routeTree } from "./routeTree.gen";

export function getRouter() {
	const router = createTanStackRouter({
		routeTree,

		context: getContext(),

		defaultErrorComponent: RouteError,
		scrollRestoration: true,
		defaultPreload: "intent",
		defaultPreloadStaleTime: 0,
		pathParamsAllowedCharacters: [":"],
		// 프로바이더 스택 — 구 main.tsx에서 이전(RouterProvider는 Start가 마운트).
		Wrap: ({ children }) => (
			<TolgeeProviderWrapper>
				<TanStackQueryProvider>{children}</TanStackQueryProvider>
			</TolgeeProviderWrapper>
		),
	});

	// 클라이언트 라우터 생성 직후 = 구 main.tsx와 동일한 init 타이밍.
	// getRouter()는 빌드타임 셸 프리렌더(Node)에서도 실행되므로 window 가드.
	if (typeof window !== "undefined") {
		initSentry(router);
	}

	return router;
}

declare module "@tanstack/react-router" {
	interface Register {
		router: ReturnType<typeof getRouter>;
	}
}
